import { EScene as e } from "../../common/type.mjs";
const E = {
  IMAGE: "image/jpg,image/png,image/jpeg,image/webp",
  VIDEO: "video/mp4,video/mov"
}, i = {
  size: "medium"
}, n = {
  [e.REOLINK]: "icon-icon-hint-error",
  [e.CAMOVUE]: "icon-bin-line"
}, c = {
  large: 24,
  medium: 24,
  small: 20
}, m = {
  ERROR: "error",
  SUCCESS: "success",
  UPLOADING: "uploading"
}, s = 100, r = 1024 * 1024;
export {
  E as ACCEPT_TYPE,
  n as CLOSE_ICON_NAME,
  m as FILE_STATUS,
  c as ICON_SIZE,
  s as ONE_HUNDRED,
  r as ONE_MEGABYTE,
  i as defaultProps
};
//# sourceMappingURL=const.mjs.map
